// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tuU18E {
  width: 100%;
  box-sizing: border-box;
  background: #f4f5f7;
  padding: var(--spacing-3);
  margin-top: calc(var(--spacing-3) - var(--spacing-7));
}

.RX9vnZ {
  width: 100%;
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 34rem);
  gap: var(--spacing-3);
  align-items: center;
  box-sizing: border-box;
}

@media (max-width: 900px) {
  .RX9vnZ {
    grid-template-columns: 1fr;
    justify-items: stretch;
  }
}

.JU7_Py {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3);
  min-width: 0;
}

.eZn4Cr {
  margin: 0;
  font-size: var(--font-size-3xl);
  font-weight: var(--font-weight-medium);
  line-height: 1.31;
  color: var(--text-neutral-dark);
  font-family: var(--font-family-clario), var(--font-family-base);
}

.Hercm7 {
  font-weight: 100;
  color: var(--brand-tr-orange);
}

.hpUMoR {
  font-weight: 700;
}

.mQyytt {
  margin: 0;
  font-size: var(--font-size-lg);
  line-height: var(--line-height-160);
  font-weight: var(--font-weight-regular);
  color: var(--text-neutral-dark);
  max-width: 23.875rem;
  font-family: var(--font-family-base);
  overflow-wrap: break-word;
}

.mkczdX {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: var(--spacing-2);
}

.j_vbJi {
  display: flex;
  flex-direction: column;
  gap: 0.285rem;
  flex-shrink: 0;
}

.Okn7RM {
  display: block;
  line-height: 0;
}

.Okn7RM:hover {
  opacity: 0.92;
}

.zLgGVa {
  display: block;
  width: 7.665rem;
  height: auto;
}

.Qu8sTV {
  flex-shrink: 0;
  width: 5.25rem;
  height: 5.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

.Qu8sTV svg {
  display: block;
}

.v83Wxp {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-width: 0;
}

.ZisklR {
  width: 100%;
  max-width: 34rem;
  border-radius: 7.16px;
  overflow: hidden;
  box-sizing: border-box;
  line-height: 0;
}

.oShaia {
  width: 100%;
  height: auto;
  display: block;
}

@media (max-width: 900px) {
  .mkczdX {
    justify-content: flex-start;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/InsideSalesBenefitsLanding/components/InsideSalesSuperAppSection/InsideSalesSuperAppSection.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,qDAAqD;AACvD;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sDAAsD;EACtD,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE;IACE,0BAA0B;IAC1B,sBAAsB;EACxB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,sCAAsC;EACtC,iBAAiB;EACjB,+BAA+B;EAC/B,+DAA+D;AACjE;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,mCAAmC;EACnC,uCAAuC;EACvC,+BAA+B;EAC/B,oBAAoB;EACpB,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,YAAY;AACd;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF","sourcesContent":[".superAppSection {\n  width: 100%;\n  box-sizing: border-box;\n  background: #f4f5f7;\n  padding: var(--spacing-3);\n  margin-top: calc(var(--spacing-3) - var(--spacing-7));\n}\n\n.card {\n  width: 100%;\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 34rem);\n  gap: var(--spacing-3);\n  align-items: center;\n  box-sizing: border-box;\n}\n\n@media (max-width: 900px) {\n  .card {\n    grid-template-columns: 1fr;\n    justify-items: stretch;\n  }\n}\n\n.copyColumn {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-3);\n  min-width: 0;\n}\n\n.headline {\n  margin: 0;\n  font-size: var(--font-size-3xl);\n  font-weight: var(--font-weight-medium);\n  line-height: 1.31;\n  color: var(--text-neutral-dark);\n  font-family: var(--font-family-clario), var(--font-family-base);\n}\n\n.headlineHighlight {\n  font-weight: 100;\n  color: var(--brand-tr-orange);\n}\n\n.headlineHighlightBold {\n  font-weight: 700;\n}\n\n.subtitle {\n  margin: 0;\n  font-size: var(--font-size-lg);\n  line-height: var(--line-height-160);\n  font-weight: var(--font-weight-regular);\n  color: var(--text-neutral-dark);\n  max-width: 23.875rem;\n  font-family: var(--font-family-base);\n  overflow-wrap: break-word;\n}\n\n.storeQrRow {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  gap: var(--spacing-2);\n}\n\n.storeStack {\n  display: flex;\n  flex-direction: column;\n  gap: 0.285rem;\n  flex-shrink: 0;\n}\n\n.storeBadgeLink {\n  display: block;\n  line-height: 0;\n}\n\n.storeBadgeLink:hover {\n  opacity: 0.92;\n}\n\n.storeBadgeImg {\n  display: block;\n  width: 7.665rem;\n  height: auto;\n}\n\n.qrWrap {\n  flex-shrink: 0;\n  width: 5.25rem;\n  height: 5.25rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n}\n\n.qrWrap svg {\n  display: block;\n}\n\n.visualColumn {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  min-width: 0;\n}\n\n.promoFrame {\n  width: 100%;\n  max-width: 34rem;\n  border-radius: 7.16px;\n  overflow: hidden;\n  box-sizing: border-box;\n  line-height: 0;\n}\n\n.promoImage {\n  width: 100%;\n  height: auto;\n  display: block;\n}\n\n@media (max-width: 900px) {\n  .storeQrRow {\n    justify-content: flex-start;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"superAppSection": `tuU18E`,
	"card": `RX9vnZ`,
	"copyColumn": `JU7_Py`,
	"headline": `eZn4Cr`,
	"headlineHighlight": `Hercm7`,
	"headlineHighlightBold": `hpUMoR`,
	"subtitle": `mQyytt`,
	"storeQrRow": `mkczdX`,
	"storeStack": `j_vbJi`,
	"storeBadgeLink": `Okn7RM`,
	"storeBadgeImg": `zLgGVa`,
	"qrWrap": `Qu8sTV`,
	"visualColumn": `v83Wxp`,
	"promoFrame": `ZisklR`,
	"promoImage": `oShaia`
};
module.exports = ___CSS_LOADER_EXPORT___;
